import React, {useState, useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import IconSelector from '@ibibo/icon-selector';

import * as S from './ShareProperties.styles';
import WhatsAppLogin from './WhatsAppLogin';
import ShareHotelPreview from './ShareHotelPreview';

import CloseIcon from '../../../../stories/Icons/CloseIcon';
// import RatingStarIcon from '../../../../stories/Icons/RatingStarIcon';

import {shareHotelListSelector} from '../redux/selectors';
import {updateShareHotelList, resetShareHotelList} from '../redux/actions';
import {shareHotelPropertiesPOST, whatsappLogin, sendWhatsAppMessage} from '../redux/thunk';
import {srpSelector} from '../../SRP/redux/selectors';

import Modal from '../../../components/Modal';

const HotelSRPShareProperties = () => {
  const dispatch = useDispatch();

  const [isClosed, setIsClosed] = useState(false);

  const shareHotelsList = useSelector(shareHotelListSelector);
  const srp = useSelector(srpSelector);

  const [agentText, setAgentText] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [dataLoader, setDataLoader] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const [acknowledgement, setAcknowledgement] = useState('');
  const [modalData, setModalData] = useState('');
  const [errorMsg, setErrorMsg] = useState('');
  const [fileNames, setFileNames] = useState(null);
  const [customerMobileNumber, setCustomerNumber] = useState('');
  const [numberError, setNumberError] = useState('');
  const [qrCode, setQRCode] = useState('');
  const [userName, setUserName] = useState('');

  useEffect(() => {
    if (userName !== '' && modalData === '') {
      setDataLoader(true);
      setShowLoader(false);
    }
  }, [userName]);

  const {srpData} = srp;
  const {city_meta_info: cityMetaInfo} = srpData;

  if (!shareHotelsList || !Object.keys(shareHotelsList).length) {
    return null;
  }

  const removeHotel = data => {
    dispatch(updateShareHotelList(data));
  };

  const resetShare = () => {
    dispatch(resetShareHotelList());
  };

  const shareHotels = async () => {
    const res = await shareHotelPropertiesPOST({
      cityMetaInfo,
      list: shareHotelsList,
    });
    setDataLoader(false);
    setModalData(res?.markdown);
    setFileNames(res?.fileNames);
  };

  const resetModal = () => {
    setModalData('');
    setFileNames('');
    setQRCode('');
    setUserName('');
    setAcknowledgement('');
  };

  const closeModal = () => {
    setShowModal(false);
    setErrorMsg('');
    resetModal();
  };

  const closeShare = () => {
    setIsClosed(true);
  };

  const openShare = () => {
    setIsClosed(false);
  };

  const callback = resp => {
    if (resp.success && resp.data) {
      if (resp.data.qrUrl) {
        setQRCode(resp.data.qrUrl);
      }
      if (resp.data.userName) {
        setUserName(resp.data.userName);
      }
    } else if (!resp.success && resp.errors && resp.errors.relogin) {
      whatsappLogin(callback);
    } else {
      let errorMsg = 'Something went wrong. Please try after sometime.';
      if (resp.errors && resp.errors.message) {
        errorMsg = resp.errors.message;
      }
      setErrorMsg(errorMsg);
      resetModal();
    }
    setShowLoader(false);
  };

  const authenticate = () => {
    resetModal();
    shareHotels();
    setShowLoader(true);
    setShowModal(true);
    whatsappLogin(callback);
  };

  const sendMessage = async () => {
    if (!customerMobileNumber || customerMobileNumber.length < 10) {
      setNumberError('Please enter a valid number');
      return;
    }
    setNumberError('');
    const postData = {
      images: [],
      contactId: `91${customerMobileNumber}`,
    };
    Object.keys(fileNames).map(key => {
      const item = fileNames[key];
      postData.images.push({
        imageId: item,
        message: agentText[key] || '',
      });
    });
    const resp = await sendWhatsAppMessage(postData);
    if (resp && resp.data) {
      setAcknowledgement(resp.data.message || '');
      setModalData('');
    }
  };

  const onTextChange = (id, val) => {
    const temp = {...agentText};
    temp[id] = val;
    setAgentText(temp);
  };

  if (isClosed) {
    return (
      <S.WrapperDiv onClick={openShare}>
        <S.InnerCollapsedWrapper>
          <S.HeaderText>Share Properties</S.HeaderText>
        </S.InnerCollapsedWrapper>
      </S.WrapperDiv>
    );
  }

  return (
    <>
      <S.WrapperDiv>
        <S.InnerWrapper>
          <S.HeaderText>
            Share Properties<S.HeaderSubText>(Max 10)</S.HeaderSubText>
            <S.CloseIconWrap>
              {shareHotelsList && <S.ResetText onClick={resetShare}>Reset</S.ResetText>}
              <CloseIcon width="1.2rem" height="1.2rem" fill="#ffffff" onClick={closeShare} />
            </S.CloseIconWrap>
          </S.HeaderText>
          <S.CardList>
            {Object.keys(shareHotelsList).map(key => {
              const data = shareHotelsList[key];
              return (
                <S.CardBlock key={key}>
                  <S.ShareCheck
                    type="checkbox"
                    id="shareBtn"
                    checked
                    onClick={() => removeHotel(data)}
                  ></S.ShareCheck>
                  <S.ShareImage src={data.t} alt="hotelImg" />
                  <S.ShareInfo>
                    {/* {(data.hr && (
                    <S.StarRating>
                      {[...Array(data.hr)].map((item, index) => (
                        <RatingStarIcon
                          key={'starIcon' + index}
                          width="1.1rem"
                          height="1.1rem"
                        />
                      ))}
                    </S.StarRating>
                  )) ||null} */}
                    <S.HotelName>{data.hn}</S.HotelName>
                    <S.Location>{data.l}</S.Location>
                    <S.TextInput
                      type="text"
                      placeholder="Type your text here"
                      value={agentText[`${key}.jpeg`] || ''}
                      onChange={e => onTextChange(`${key}.jpeg`, e.target.value)}
                    />
                  </S.ShareInfo>
                </S.CardBlock>
              );
            })}
          </S.CardList>
        </S.InnerWrapper>

        <S.Footer onClick={authenticate}>Share</S.Footer>
      </S.WrapperDiv>

      <Modal isOpen={showModal} closeModal={closeModal} modalStyles={{width: '62vw'}}>
        <S.ModalHeader>Share Properties</S.ModalHeader>
        <S.ModalContainer>
          <S.ModalContent>
            {(showLoader && !dataLoader && (
              <S.ModalContentLoader>
                <IconSelector iconKey="linearloader" />
              </S.ModalContentLoader>
            )) ||
              null}
            {(!showLoader && dataLoader && (
              <S.ModalContentLoader>
                <IconSelector iconKey="linearloader" />
              </S.ModalContentLoader>
            )) ||
              null}
            {(acknowledgement && (
              <>
                <S.AcknowledgeContainer>
                  <S.AcknowledgeText>{acknowledgement}</S.AcknowledgeText>
                  <S.ModalButton onClick={closeModal}>Ok</S.ModalButton>
                </S.AcknowledgeContainer>
              </>
            )) ||
              null}
            {(errorMsg && (
              <>
                <S.ErrorText>{errorMsg}</S.ErrorText>
              </>
            )) ||
              null}
            {qrCode !== '' && userName === '' ? (
              <WhatsAppLogin qrCode={qrCode} relogin={() => whatsappLogin(callback)} />
            ) : null}
            {(modalData && userName && <ShareHotelPreview modalData={modalData} />) || null}
          </S.ModalContent>
        </S.ModalContainer>
        <S.ModalFooter>
          {(userName && (
            <>
              <S.UserInput>
                <img
                  src="https://assets-gos3.goibibo.com/whats_logo-1597597257.png"
                  width="39px"
                  height="39px"
                />
              </S.UserInput>
              <S.UserInput>
                <S.InputBox
                  type="text"
                  placeholder="Customer mobile number"
                  maxLength={10}
                  autoFocus
                  value={customerMobileNumber}
                  onChange={e => {
                    const val = e.target.value;
                    const re = /^[0-9]+$/;
                    if (val === '' || re.test(val)) {
                      setCustomerNumber(val);
                    }
                  }}
                />
                {numberError ? (
                  <S.ErrorText margin="0 2rem" fs="1.2rem">
                    {numberError}
                  </S.ErrorText>
                ) : (
                  <S.UserInfo>
                    Sent from: <span>{userName}</span>
                  </S.UserInfo>
                )}
              </S.UserInput>
              <S.ModalButton disabled={!modalData} onClick={sendMessage}>
                Share
              </S.ModalButton>
            </>
          )) ||
            null}
        </S.ModalFooter>
      </Modal>
    </>
  );
};

export default HotelSRPShareProperties;
